<div class="ods-input-container">
  <label [id]="labelId" [attr.for]="labelFor" class="label">
    <span class="label-text">{{ labelTextBeforeRequired }}</span>
    <span *ngIf="isRequired" class="required-text">(required)</span>
    <span *ngIf="optional" class="optional-text">(optional)</span>
    <span *ngIf="labelTextAfterRequired" class="label-text label-suffix">{{ labelTextAfterRequired }}</span>
    <span *ngIf="labelHint" class="required-text">{{ labelHint }}</span>
    <mat-icon *ngIf="infoTip" aria-hidden="false" [attr.aria-label]="infoTip" [matTooltip]="infoTip">info</mat-icon>
  </label>
  <ng-content></ng-content>
</div>
